import {BaseWebsiteResource} from "./base-website-resource";
import {OpeningTime} from "./opening-time";
import {Location} from "./location";

export class SpecialOpeningTime extends BaseWebsiteResource {
  public openingTimes: OpeningTime[];
  public date: Date | null;
  public location: Location | null;

  constructor(el: any = {}) {
    super(el);
    this.openingTimes = (el.openingTimes || []).map(
      (l: any) => new OpeningTime(l),
    );
    this.location = new Location(el.location || {});
    this.date = el.date ? new Date(el.date) : null;
  }


  public get rowLabel(): string {
    return `${this.date ? this.date.toLocaleDateString() : ""} ${this.location?.name || ""} ${this.getLabel()}`;
  }

  public override toJson(): any {
    return {
      ...super.toJson(),
      openingTimes: this.openingTimes.map(el => el.toJson()),
      location: this.location ? {id: this.location.id} : null,
      date: this.date ? this.date.toISOString() : null,
    };
  }

  public override getLabel(): string {
    if (this.openingTimes.length === 0) {
      return "Geschlossen";
    }
    return this.openingTimes.map(el => el.timeLabel).join(", ");
  }

  override getSearchIndex(): string[] {
    return [...super.getSearchIndex(), this.rowLabel];
  }

  public override clone(): SpecialOpeningTime {
    return new SpecialOpeningTime({...this.toJson(), id: undefined});
  }
}
